<div class="container py-3 d-flex flex-column gap-3">
  <div class="d-flex align-items-center justify-content-between">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab === 'all'" (click)="setTab('all')">
          All
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab === 'unread'" (click)="setTab('unread')">
          Unread
          @if (unreadCount > 0) {
            <span class="badge bg-danger ms-2">{{ unreadCount }}</span>
          }
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab === 'mentions'" (click)="setTab('mentions')">
          Mentions
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab === 'system'" (click)="setTab('system')">
          System
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab === 'invites'" (click)="setTab('invites')">
          Invites
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab === 'archived'" (click)="setTab('archived')">
          Archived
        </button>
      </li>
    </ul>
    <div class="d-flex gap-2">
      <button class="btn btn-sm btn-outline-secondary" (click)="markAllAsRead()" [disabled]="unreadCount === 0">
        Mark all as read
      </button>
    </div>
  </div>

  @if (activeTab !== 'invites') {
    <div class="card">
      <div class="card-body p-0">
        <ul class="list-group list-group-flush">
          @for (n of visibleNotifications; track n.id) {
            <li class="list-group-item d-flex align-items-start justify-content-between"
              >
              <div class="me-3">
                <div class="fw-semibold">{{ n.title }}</div>
                <div class="text-muted small">{{ n.message }}</div>
              </div>
              <div class="text-end">
                <div class="small text-muted">{{ n.timestamp | date:'short' }}</div>
                @if (isInviteNotification(n) && !n.read) {
                  <div class="d-flex gap-2 justify-content-end mt-2">
                    <button
                      class="btn btn-sm btn-outline-primary"
                      type="button"
                      (click)="acceptInviteNotification(n)"
                      [disabled]="isInviteActionPendingForNotification(n)"
                    >
                      @if (isPending('notification', n.id, 'accept')) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      }
                      Accept
                    </button>
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      (click)="declineInviteNotification(n)"
                      [disabled]="isInviteActionPendingForNotification(n)"
                    >
                      @if (isPending('notification', n.id, 'decline')) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      }
                      Decline
                    </button>
                  </div>
                } @else if (!n.read) {
                  <button
                    class="btn btn-sm btn-outline-primary mt-2"
                    (click)="markAsRead(n.id)"
                  >Mark as read</button>
                }

                <div class="mt-2">
                  @if (!n.archived) {
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="archive(n)">
                      Hide
                    </button>
                  } @else {
                    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="restore(n)">
                      Restore
                    </button>
                  }
                </div>
              </div>
            </li>
          }
          @if (visibleNotifications.length === 0) {
            <li class="list-group-item text-center text-muted">
              No notifications
            </li>
          }
        </ul>
      </div>
    </div>
  }

  @if (activeTab === 'invites') {
    <div class="card">
      <div class="card-body p-0">
        <ul class="list-group list-group-flush">
          @for (i of invites; track i.id) {
            <li class="list-group-item d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-3">
                <span class="badge bg-primary text-uppercase">{{ i.type }}</span>
                <div>
                  <div class="fw-semibold">{{ i.name }}</div>
                  <div class="text-muted small">Invited by {{ i.inviter }} • {{ i.timestamp }}</div>
                </div>
              </div>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-sm btn-outline-primary"
                  (click)="acceptInvite(i.id)"
                  [disabled]="isInviteActionPendingForInviteRow(i.id)"
                >
                  @if (isPending('invite', i.id, 'accept')) {
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  }
                  Accept
                </button>
                <button
                  class="btn btn-sm btn-outline-secondary"
                  (click)="declineInvite(i.id)"
                  [disabled]="isInviteActionPendingForInviteRow(i.id)"
                >
                  @if (isPending('invite', i.id, 'decline')) {
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  }
                  Decline
                </button>
              </div>
            </li>
          }
          @if (invites.length === 0) {
            <li class="list-group-item text-center text-muted">
              No pending invites
            </li>
          }
        </ul>
      </div>
    </div>
  }
</div>
